import React from 'react'
import style from './style.css'



const Tag = ({ children, color = 'orange' }) => {
    return (
        <span className={`${style.tag} ${style[color] || ''}`}>
            {children}
        </span>
    );
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/atoms/Tag/index.js